<template>
  <a-modal
    :title="title"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    :okText="okText"
    :cancelText="cancelText"
    :confirmLoading="confirmLoading"
  >
    <a-form :form="form" layout="vertical">
      <a-form-item>
        <a-textarea
          v-decorator="[
            'reason',
            {
              rules: [{ required: true, message: requiredMessage }]
            }
          ]"
          :placeholder="placeholder"
          :rows="4"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  name: 'RejectModal',
  props: {
    onReject: {
      type: Function,
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'RejectModal'
    },
    okText: {
      type: String,
      default: 'confirm'
    },
    cancelText: {
      type: String,
      default: 'cancel'
    },
    placeholder: {
      type: String,
      default: 'Please enter '
    },
    requiredMessage: {
      type: String,
      default: 'Please enter the rejection reason'
    }
  },
  data() {
    return {
      confirmLoading: false,
      form: this.$form.createForm(this)
    }
  },
  methods: {
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          // 调用父组件传入的拒绝回调
          if (this.onReject) {
            this.onReject(values.reason)
              .then(() => {
                this.resetForm()
                this.$emit('cancel')
                this.confirmLoading = false
              })
              .catch(() => {
                this.$emit('cancel')
                this.confirmLoading = false
              })
          } else {
            this.resetForm()
            this.$emit('cancel')
            this.confirmLoading = false
          }
        }
      })
    },
    handleCancel() {
      this.resetForm()
      this.$emit('cancel')
    },
    resetForm() {
      this.form.resetFields()
    }
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        this.resetForm()
      }
    }
  }
}
</script>